class AutocompleteEventBus {
  constructor () {
    this.events = {}
  }

  subscribe (eventName, callback) {
    if (!this.events[eventName]) {
      this.events[eventName] = []
    }
    this.events[eventName].push(callback)
  }

  unsubscribe (eventName, callback) {
    if (!this.events[eventName]) return
    this.events[eventName] = this.events[eventName].filter(
      cb => cb !== callback,
    )
  }

  publish (eventName, data) {
    if (!this.events[eventName]) return
    this.events[eventName].forEach(callback => callback(data))
  }
}

window.theme.autocompleteResults = {}
window.theme.autocompleteResults = window.theme.autocompleteResults || {}
window.theme.autocompleteResults.eventBus = new AutocompleteEventBus()
